"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.getTheme = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("./menu/styles");

var _styles2 = require("./dropdown-indicator/styles");

var _styles3 = require("./value-container/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getTheme = function getTheme(view, bg) {
  return function (theme) {
    return _objectSpread(_objectSpread({}, theme), {}, {
      borderRadius: {
        usual: '0.625rem',
        tall: 'var(--border-radius-def)'
      }[view],
      colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
        primary: 'var(--color-flomni-blue-70)',
        neutral30: 'var(--color-flomni-gray-40)'
      }),
      font: {
        // @include text-reg-16
        // @include text-reg-14
        fontSize: {
          usual: '0.875rem',
          tall: '1rem'
        }[view],
        fontWeight: 400,
        lineHeight: {
          usual: '1rem',
          tall: '1.125rem'
        }[view]
      },
      spacing: _objectSpread(_objectSpread({}, theme.spacing), {}, {
        controlHeight: {
          usual: '2.25rem',
          tall: '2.625rem'
        }[view]
      }),
      fontColor: {
        usual: 'var(--color-flomni-gray-90)',
        tall: 'var(--color-flomni-blue-70)'
      }[view],
      arrowColor: {
        usual: 'var(--color-flomni-gray-40)',
        tall: 'var(--color-flomni-blue-70)'
      }[view],
      valuePadding: {
        usual: '0.5rem',
        tall: '0.9375rem'
      }[view],
      controlBg: {
        white: '#fff',
        transparent: 'transparent'
      }[bg]
    });
  };
};

exports.getTheme = getTheme;

var input = function input(provided, state) {
  var theme = state.theme,
      value = state.value;
  return _objectSpread(_objectSpread(_objectSpread({}, provided), {}, {
    color: 'var(--color-flomni-gray-90)',
    margin: '0 0.125rem',
    paddingBottom: 0,
    paddingTop: 0
  }, theme.font), {}, {
    position: value ? 'static' : 'absolute',
    top: value ? 'auto' : '50%',
    transform: value ? 'none' : 'translateY(-50%)'
  });
};

var singleValue = function singleValue(provided, state) {
  var theme = state.theme;
  return _objectSpread(_objectSpread({}, provided), {}, {
    marginLeft: '0.125rem',
    marginRight: '0.125rem',
    color: theme.fontColor,
    position: 'static',
    top: 'auto',
    transform: 'none',
    maxWidth: 'none'
  }, theme.font);
};

var placeholder = function placeholder(provided, state) {
  var theme = state.theme;
  return _objectSpread(_objectSpread({}, provided), {}, {
    color: 'var(--color-flomni-gray-70)',
    marginLeft: '0.125rem',
    marginRight: '0.125rem',
    position: 'static',
    top: 'auto',
    transform: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, theme.font);
};

var indicatorSeparator = function indicatorSeparator(provided, state) {
  return _objectSpread(_objectSpread({}, provided), {}, {
    display: 'none'
  });
};

var clearIndicator = function clearIndicator(provided, state) {
  return _objectSpread(_objectSpread({}, provided), {}, {
    padding: '0.4375rem'
  });
};

var menuList = function menuList(provided, state) {
  return _objectSpread(_objectSpread({}, provided), {}, {
    paddingTop: '0.625rem',
    paddingBottom: '0.625rem',
    maxHeight: '18.75rem'
  });
};

var menuPortal = function menuPortal(provided) {
  return _objectSpread(_objectSpread({}, provided), {}, {
    zIndex: 999
  });
};

var option = function option(provided, state) {
  var isSelected = state.isSelected,
      isDisabled = state.isDisabled;
  return _objectSpread(_objectSpread({}, provided), {}, {
    // @include typography_creator(1rem, 400, 1.5rem);
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.5rem',
    color: isSelected ? 'var(--color-flomni-blue-70)' : 'var(--color-flomni-gray-90)',
    backgroundColor: 'transparent',
    transition: 'opacity var(--animation-timing-def) ease',
    padding: '0.625rem 1.5625rem',
    cursor: isDisabled ? 'default' : 'pointer',
    opacity: isDisabled ? 0.3 : 1,
    overflowWrap: 'break-word',
    '&:hover': _objectSpread(_objectSpread({}, provided['&:hover']), {}, {
      opacity: isDisabled ? 0.3 : isSelected ? 1 : 0.7,
      backgroundColor: 'transparent'
    }),
    '&:active': _objectSpread(_objectSpread({}, provided['&:active']), {}, {
      opacity: isDisabled ? 0.3 : isSelected ? 1 : 0.5,
      backgroundColor: 'transparent'
    })
  });
};

var styles = {
  singleValue: singleValue,
  placeholder: placeholder,
  indicatorSeparator: indicatorSeparator,
  clearIndicator: clearIndicator,
  menuList: menuList,
  dropdownIndicator: _styles2.dropdownIndicator,
  menu: _styles.menu,
  menuPortal: menuPortal,
  option: option,
  input: input,
  valueContainer: _styles3.valueContainer
};
exports.styles = styles;